import cn from 'classnames';
import { HTMLAttributes } from 'react';

import { IGalleryCounter } from './';

export function GalleryCounter(
  props: IGalleryCounter & HTMLAttributes<HTMLElement>,
) {
  const { count, activeIndex, action } = props;

  const previousItem = () => {
    if (activeIndex > 0) action(activeIndex - 1);
  };
  const nextItem = () => {
    if (activeIndex < count - 1) action(activeIndex + 1);
  };

  return (
    <div
      className={cn(
        'flex flex-row space-x-8 px-4 lg:px-12 items-center lg:h-full w-full lg:items-end relative justify-between lg:justify-start lg:mt-[100%]',
      )}
    >
      <span className={cn('flex flex-row space-x-2 style-heading-xxxs')}>
        <span>{activeIndex + 1}</span>
        <span className={cn('text-grey-40')}>/</span>
        <span className={cn('text-grey-40')}>{count}</span>
      </span>
      <span className={cn('flex flex-row space-x-8 style-heading-xxxs')}>
        <span onClick={previousItem} className={cn('cursor-pointer')}>
          <svg
            width="20"
            height="17"
            viewBox="0 0 20 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.4 16.9033L0.275 9.57619C-0.0916665 9.19912 -0.0916665 8.60751 0.275 8.23045L7.4 0.903319L8.85 2.24907L3.32931 7.90332L20 7.90332L20 9.90332L3.32931 9.90332L8.85 15.5576L7.4 16.9033Z"
              fill={activeIndex > 0 ? '#0D0D0D' : '#AFAFAF'}
            />
          </svg>
        </span>
        <span onClick={nextItem} className={cn('cursor-pointer')}>
          <svg
            width="20"
            height="17"
            viewBox="0 0 20 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.6 0.90332L19.725 8.23045C20.0917 8.60752 20.0917 9.19913 19.725 9.57619L12.6 16.9033L11.15 15.5576L16.6707 9.90332L0 9.90332L0 7.90332L16.6707 7.90332L11.15 2.24907L12.6 0.90332Z"
              fill={activeIndex < count - 1 ? '#0D0D0D' : '#AFAFAF'}
            />
          </svg>
        </span>
      </span>
    </div>
  );
}
